import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Typography } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InfiniteScroll from 'react-infinite-scroller';
import Radio from '../../assets/Radio';

const checkboxStyle = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(4, 2.5),
    color: 'black !important',
  },
  boderBottom: {
    borderBottom: `${theme.spacing(0.125)}px solid black`,
  },
  newPatient: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: theme.spacing(4, 2.5),
    textAlign: 'center',
  },
  box: {
    display: 'flex',
  },
  spreadBox: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    boxShadow: 'none',
    textTransform: 'none',
    padding: theme.spacing(0.75, 0.5),
    margin: theme.spacing(0.4),
    minWidth: theme.spacing(6.2),
  },
}));

export default function RadioButtonList({
  list,
  filterValue,
  pendingDataToPaginate,
  onPagination,
  onChangeFilterValue,
  searchCompleted,
  isListEmpty,
}) {
  const styles = checkboxStyle();

  const handleStatusValue = (event) => {
    event.stopPropagation();
    onChangeFilterValue(event.target.value);
  };

  const radioElements = list.map((element, index) => {
    const isLast = index === list.length - 1;
    const label = element.name ? element.name : String(element.id);

    return (
      <Box key={element.id}>
        <RadioGroup aria-label="centers" name="centers" value={filterValue} onChange={handleStatusValue}>
          <FormControlLabel
            value={element.id.toString()}
            control={<Radio />}
            label={label}
          />
        </RadioGroup>
        {!isLast && (
          <Box className={styles.boderBottom} display="flex" flexGrow={1} />
        )}
      </Box>
    );
  });

  return (
    <>
      {searchCompleted && !isListEmpty && list.length > 0
        && (
        <Box component={FormControl} display="flex" flexGrow={1}>
          <InfiniteScroll
            pageStart={0}
            loadMore={onPagination}
            hasMore={pendingDataToPaginate}
          >
            {radioElements}
          </InfiniteScroll>
        </Box>
        )}
      {searchCompleted && list.length === 0
         && (
           <Box>
             <Box className={styles.newPatient} textAlign="center">
               <Typography variant="subtitle1">
                 We could not find any records that match the search criteria.
                 Please try again with a different search value.
               </Typography>
             </Box>
           </Box>
         )}
    </>
  );
}
